export default "__VITE_ASSET__DVj6f0Q0__"